import TrainingCourseListPage from '../TrainingCourses/ListPage';
import {useTranslation} from 'react-i18next';
import usePageMeta from '../../services/page-meta';

export default function MyCoursesListPage() {
    const {t} = useTranslation();
    usePageMeta({
        title: t('courses.my.title', t('courses.title')),
        description: t('app.description'),
        keywords: t('app.keywords'),
    });

    return <TrainingCourseListPage isTesting={false} tab="my" />;
}
